import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId, useCurrentJobId } from "@/hooks";
import { httpClient } from "@/lib/http";
import { CandidacyComment, HttpResponse } from "@/types";

export function useDeleteCandidacyComment() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  const mutation = useMutation({
    mutationFn: async ({
      candidacyCommentId,
      candidacyId,
    }: {
      candidacyCommentId: number;
      candidacyId: string;
    }) => {
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/candidacies/${candidacyId}/candidacy_comments/${candidacyCommentId}`;
      const res = await httpClient.delete<
        CandidacyComment,
        HttpResponse<CandidacyComment>
      >(path);

      return res.data;
    },
  });

  return mutation;
}
